module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Right-70ce6ef676926b0cdeda1c3cd7211757.svg";